import { createContext, useContext, useState } from "react";

const HeaderContext = createContext();

export function HeaderProvider({ children }) {
  const [actions, setActions] = useState([]);
  const [subtitle, setSubtitle] = useState(null);
  const [searchProps, setSearchProps] = useState(null);

  const value = {
    actions,
    setActions,
    subtitle,
    setSubtitle,
    searchProps,
    setSearchProps,
  };

  return (
    <HeaderContext.Provider value={value}>{children}</HeaderContext.Provider>
  );
}

export function useHeader() {
  const context = useContext(HeaderContext);
  if (context === undefined) {
    throw new Error("useHeader must be used within a HeaderProvider");
  }
  return context;
}
